
import {
  AutoMotive,
  Contests,
  ECommerce,
  Facebook,
  GroupChat,
  HealthFitness,
  HomeServices,
  Instagram,
  LinkedIn,
  Misc,
  Nightlife,
  PromoInvite,
  RealEstate,
  RealFeedback,
  Restaurants,
  Retail,
  SocialInteractions,
  TechRepairs,
  TravelTours,
  ViaCode,
  Youtube,
} from "./Icons";

export const navLinks = [
  {
    link: "Menu",
    url: "/",
  },
  {
    link: "Menu",
    url: "/",
  },
  {
    link: "Menu",
    url: "/",
  },
  {
    link: "Menu",
    url: "/",
  },
];

export const toolCards = [
  {
    icon: <AutoMotive />,
    title: "Automotive",
  },
  // {
  //   icon: <TravelTours />,
  //   title: "Travel Tours",
  // },
  {
    icon: <TechRepairs />,
    title: "Tech Products",
  },
  {
    icon: <HealthFitness />,
    title: "Health Care",
  },
  // {
  //   icon: <ECommerce />,
  //   title: "E-Commerce Apparel",
  // },
  // {
  //   icon: <HomeServices />,
  //   title: "Home Goods",
  // },
  // {
  //   icon: <Contests />,
  //   title: "Contests",
  // },
  // {
  //   icon: <Retail />,
  //   title: "Retail",
  // },
   {
    icon: <RealEstate />,
    title: "Real Estate",
   },
  // {
  //   icon: <Nightlife />,
  //   title: "Nightlife",
  // },
  // {
  //   icon: <Restaurants />,
  //   title: "Restaurants",
  // },
  {
    icon: <Misc />,
    title: "Misc",
  },
];
export const promotionsCards = [
  {
    icon: <PromoInvite />,
    title: "Promo Invites",
    description: "Incentive helps creators meet their followers.",
  },
  {
    icon: <GroupChat />,
    title: "Group Chat to Connect",
    description:
      "Communication builds community and excitement between like-minded people.",
  },
  {
    icon: <ViaCode />,
    title: "Invite via Public Link",
    description:
      "Use social media or any other platform via a public link to sign up and chat with followers.",
  },
  {
    icon: <RealFeedback />,
    title: "Chat with Follower Before Event",
    description:
      "Leave private reviews for  hosts to ensure trust and safety.",
  },
  {
    icon: <SocialInteractions />,
    title: "Social Interactions",
    description:
      "Grow your community and meet your followers.",
  },
];
// Footer
export const footerSocialIcons = [
  {
    icon: <Facebook />,
    url: "https://www.facebook.com/",
  },
  {
    icon: <LinkedIn />,
    url: "https://in.linkedin.com/?src=go-pa&trk=sem-ga_campid.14650114788_asid.151761418307_crid.657403558721_kw.linkedin%20login_d.c_tid.kwd-12704335873_n.g_mt.e_geo.9303870&mcid=6844056167778418689&cid=&gad_source=1&gclid=CjwKCAiAivGuBhBEEiwAWiFmYdfFRVfE2przO6S8TTtmbBpmHt4S7Ai-tKKFjXKLTOtNJQSXi6sY3xoCzFkQAvD_BwE&gclsrc=aw.ds",
  },
  {
    icon: <Instagram />,
    url: "https://www.instagram.com/",
  },
  {
    icon: <Youtube />,
    url: "https://www.youtube.com/",
  },
];
export const standardSpecification = [
  "Unlimited Email Accounts",
  "Unlimited Email Warmup",
  "1000 Active Leads",
  "5000 Emails Monthly",
  "Live Chat Support",
];
export const enterpriseSpecification = [
  "Unlimited Email Accounts",
  "Unlimited Email Warmup",
  "1000 Active Leads",
  "5000 Emails Monthly",
  "Live Chat Support",
];
